<div *ngIf="showVideoWindow ==='showReRouteMessage'">
    <div class="mt-5 pt-5">
        <div class="d-flex justify-content-center align-items-center">
            {{reRouteMessage}}
        </div>
    </div>
</div>

<div *ngIf="showVideoWindow ==='PermissionScreen'" class="fullScreenDiv">
    <div class="d-flex justify-content-center align-items-center">
        <div class="p-3 m-3">
            <div class="container">
                <div class="row mt-3 mb-3">
                    <div class="col-12 d-flex justify-content-center align-items-center">
                        <h3>Allow Camera and Microphone Access</h3>
                    </div>
                </div>
                <div class="row mt-3 mb-3">
                    <div class="col-12 d-flex justify-content-end align-items-center">
                        <div>
                            <ul>
                                <li>
                                    To ensure you make the most of our meeting platform, we kindly request access to your camera and microphone. Granting these permissions will enable you to participate fully in meetings, engage with colleagues, and collaborate effectively. 
                                </li>
                                <li>
                                    Your privacy and security are our top priorities. Rest assured that we only use these permissions for meeting-related purposes, and your data remains protected.
                                </li>
                            </ul>
                            
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-center mt-3 mb-3">

                    <table >
                        <tbody>
                            <tr  >
                                <td class="mt-3 mb-3">
                                    <a (click)="getCamAccessFromUser()" class="anchortag" type="button">Click here to Grant Camera Permission</a>
                                </td>
                                <td class="mt-3 mb-3">
                                    <span *ngIf="isCameraPermitted">
                                        &nbsp; &nbsp;<em  class="fa fa-check-circle" ></em>
                                    </span>
                                    <!-- <span *ngIf="!isCameraPermitted">
                                        &nbsp; &nbsp;<em  class="fa fa-times-circle" ></em>
                                    </span> -->
                                </td>
                            </tr>
                            <tr  >
                                <td class="mt-3 mb-3">
                                    <a (click)="getMicAccessFromUser()" class="anchortag"  type="button">Click here to Grant Microphone Permission</a>
                                </td>
                                <td class="mt-3 mb-3">
                                    <span *ngIf="isMicroPhonePermitted">
                                        &nbsp; &nbsp;<em  class="fa fa-check-circle" ></em>
                                    </span>
                                    <!-- <span *ngIf="!isMicroPhonePermitted">
                                        &nbsp; &nbsp;<em  class="fa fa-times-circle" ></em>
                                    </span> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <div class=" mt-3 mb-3">

                </div>

                <div class="row mt-3 mb-3">
                    <div class="col-12 d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="showRejectionMessage">
                            <div *ngIf="!isMicroPhonePermitted && !isCameraPermitted">
                                You have rejected Camera and Microphone Permission
                            </div>
                            <div *ngIf="!isMicroPhonePermitted && isCameraPermitted">
                                You have rejected Microphone Permission
                            </div>
                            <div *ngIf="!isCameraPermitted && isMicroPhonePermitted">
                                You have rejected Camera Permission
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="row mt-3 mb-3">
                    <div class="col-12 d-flex justify-content-center align-items-center">
                        <button (click)="proccedToPreviewScreen()" class="m-1 btn btn" type="button">PROCEED
                            <em class="fa fa-chevron-right" aria-hidden="true"></em>
                        </button>
                    </div>
                </div>



            </div>
        </div>
    </div>
</div>
<div *ngIf="showVideoWindow==='PreviewVideoScreen'" class="fullScreenDiv">
    <div class="container-fluid mt-5">
        <div class="row flex-column-reverse flex-lg-row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <section>
                    <div *ngIf="!isCameraOn" >
                        <div id="videoPlaceholderName" *ngIf="videoPlaceholderNameHidden" class="text-center" >{{localUserName}}</div>
                        <div class="centerPreviewVideo" id="videoPlaceholder" *ngIf="videoPlaceholderHidden" >
                            <div class="hei50Per wid80per borderRad">
                                <div class="previewScreenUserLogo">
                                    {{localUserNameInitials}}
                                </div>
                            </div>  
                        </div>
                    </div>
                    <div *ngIf="isCameraOn" class="centerPreviewVideo" id="previewVideoView">
                        <app-preview-video-call [videoPreview]="previewVideoStream" ></app-preview-video-call>
                    </div>
                    <div class="row">
                        <div class="col-12 text-center">
                            <button title="turn on video" *ngIf="previewVideoOnOff == true && isVideoControlEnabled" class="m-1 btn btn-sm" id="start-video-button-preview" type="button" (click)="initializeCameraPreview();">
                                <img class="buttonImg" src="./assets/meetingIcons/Video-Off.svg" alt="">
                            </button>
                            <button title="turn off video" *ngIf="previewVideoOnOff == false && isVideoControlEnabled" class="m-1 btn btn-sm" id="start-video-button-preview" type="button" (click)="stopVideoPreviewButtonClick();">
                                <img class="buttonImg" src="./assets/meetingIcons/Video.svg" alt="">
                            </button>
                            <button title="turn on mic" *ngIf="previewMuteOnOff == true && isAudioControlEnabled" class="m-1 btn btn-sm" type="button" (click)="previewMute(); previewMuteOnOff = false">
                                <img class="buttonImg" src="./assets/meetingIcons/UnMute.svg" alt="">
                            </button>
                            <button title="turn off mic" *ngIf="previewMuteOnOff == false && isAudioControlEnabled" class="m-1 btn btn-sm" type="button" (click)="previewUnmute(); previewMuteOnOff = true">
                                <img class="buttonImg" src="./assets/meetingIcons/Mute.svg" alt="">
                            </button>
                        </div>
                    </div>
                </section>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 text-center align-items-center">
                <section>
                    <div>
                        <h3 class="mb-3">
                            <strong>{{meetingTitle}}</strong>
                        </h3>
                        <div class="container text-center">
                            <div>
                                <p class="p-0 m-0"><strong>Start Time</strong></p>
                            </div>
                            <div>
                                <p>{{meetingStartTime}}</p>
                            </div>
                            <div>
                                <p class="p-0 m-0"><strong>Speaker</strong></p>
                            </div>
                            <div>
                                <p>{{speakerName}}</p>
                            </div>
                            <div>
                                <p class="p-0 m-0"><strong>Description</strong></p>
                            </div>
                            <div class="discriptionBoxContainer" >
                                <p innerHTML="{{meetingDescription}}"></p>
                            </div>
                        </div>
                        <h4 class="mb-3">
                            <strong >Ready to Join?</strong>
                        </h4>
                        <div *ngIf="!isAdminJoined" >
                            Please wait till the Admin joins the meeting
                        </div>
                        <div>
                            <button class="m-1 btn" *ngIf="initializeCallAgentButton && isAdminJoined" id="initialize-teams-call-agent" type="button" (click)="initializeCallAgentButtonClick()">Click here to join</button>
                            <button class="m-1 btn" *ngIf="initializeCallAgentButton && !isAdminJoined" id="initialize-teams-call-agent" type="button" disabled>Click here to join</button>
                        </div>  
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showVideoWindow==='VideoScreen'" class="fullScreenContainer border showHeader" >
    <p class="m-0 p-0 text-danger text-center font15Px blinking">
        <em class="fa fa-dot-circle-o" aria-hidden="true"></em>  As per our meeting policy, please note that the meeting is being automatically recorded. If you have any privacy concerns, feel free to review our <span class="anchortag">Privacy Policy</span>. Thank you for your understanding. 
    </p>
    <div #snackbar id="snackbar">{{ userLeftMessageSnackBar }}</div>
    <div [hidden]="!higherScreenRes || !higherScreenResUser" class="workScreenDiv row pt-0">
        <div [ngClass]="{'col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 video-container border text-center p-0 m-0' : isScreenShared }" 
                class="d-flex justify-content-center align-items-center" >
            <div  class=" w-75">
                <ng-container *ngIf="isLocalScreenShared">
                    <app-local-screenshare-container [localScreenShareElement]="localScreenShareStream" ></app-local-screenshare-container>               
                </ng-container>
                <ng-container *ngIf="isRemoteScreenShared">
                    <ng-container *ngFor="let participant of remoteParticipantsState | dominantSpeaker; index as i" >
                        <ng-container *ngFor="let videoType of participant.remoteParticipant.videoStreams">
                            <ng-container *ngIf="videoType._mediaStreamType == 'ScreenSharing'">
                                    <ng-container *ngIf="videoType._isAvailable">
                                        <app-screenshare-container [screenShareElement]="remoteScreenShareStream"></app-screenshare-container>
                                    </ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div [ngClass]="{   
            'col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 laptop-screen' : isScreenShared, 
            'col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12' : messageUserBox &&  !isScreenShared,  
            'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12': !messageUserBox && !isScreenShared,
            'd-none' : (isScreenShared && showMessageBox) || (isScreenShared && showUserList)
            }" 
            class="video-container border text-center p-0 m-0">
            <div class="remoteVideoContainer">
                <div class="mt15per" *ngIf="remoteParticipantsState.length==0">
                    Welcome! We're just waiting for a few more participants to join the meeting. In the meantime, feel free to grab a cup of coffee or stretch your legs. We'll get started shortly!
                </div>
                <ng-container class="stateVariableForLoop" *ngFor="let participant of remoteParticipantsState; index as i" >
                    <ng-container class="participantvideostreamforloop" *ngFor="let videoType of participant.remoteParticipant.videoStreams">
                        <ng-container class="typevideo div tag" *ngIf="videoType._mediaStreamType == 'Video'">
                            <div class="m-1 p-1 participantContainerCard" [ngClass]="getClassBasedOnUserCount(remoteParticipantsState.length)">
                                <ng-container *ngIf="videoType._isAvailable">
                                    <app-video-container [videoElement]="participant.videoRendererDiv" ></app-video-container>
                                </ng-container>
                                <ng-container *ngIf="!videoType._isAvailable">
                                    <div [ngClass]="{'userInitialLogo':!isScreenShared,'userInitialLogoSS':isScreenShared}">
                                        {{createUserInitials(participant.remoteParticipant._displayName)}}
                                    </div>
                                </ng-container>
                                <div class="row justify-content-center align-items-center m-0 p-0">
                                    <div [ngClass]="{'col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 m-0 p-0':!isScreenShared,'screenShared col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 m-0 p-0':isScreenShared}" class="userNameText" >
                                        <span title="{{participant.remoteParticipant._displayName}}">
                                            {{participant.remoteParticipant._displayName}}
                                        </span>
                                    </div>
                                    <div [ngClass]="{'col-2 col-sm-2 col-md-2 col-lg-2 col-xl-1 m-0 p-0':!isScreenShared,'screenShared col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 m-0 p-0':isScreenShared}" >
                                        <span *ngIf="videoType._isAvailable">
                                            <img class="userlistSvg"  src="./assets/meetingIcons/Video.svg" alt="">
                                        </span>
                                        <span *ngIf="!videoType._isAvailable">
                                            <img class="userlistSvg" src="./assets/meetingIcons/Video-Off.svg" alt=""> 
                                        </span>
                                    </div>
                                    <div [ngClass]="{'col-2 col-sm-2 col-md-2 col-lg-2 col-xl-1 m-0 p-0':!isScreenShared,'screenShared col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 m-0 p-0':isScreenShared}" >
                                        <span *ngIf="participant.remoteParticipant._isMuted" >
                                            <img class="userlistSvg"  src="./assets/meetingIcons/UnMute.svg" alt=""> 
                                        </span>
                                        <span *ngIf="!participant.remoteParticipant._isMuted" >
                                            <img class="userlistSvg"   src="./assets/meetingIcons/Mute.svg" alt="">
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div *ngIf="isChatEnabled" [ngClass]="{
            'col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12' : showMessageBox, 
            'd-none': !showMessageBox || showUserList && !isScreenShared 
            }" 
            class="chatbox-container border" >
            <div #chatContainer [ngClass]="{'chatThreadContainer':!isFileUploading,'chatThreadContainerWhileFileUpload':isFileUploading}">
                <div *ngFor="let message of chatMessages; let i = index">
                    <div class="text-left m-1 receiverChatMessage" *ngIf="message.senderDisplayName!=undefined && message.message!=undefined ">
                        <div *ngIf="calleeTeamsUserId != message?.sender?.communicationUserId">
                            <div class="senderReceiver">
                                <div class="m-1">
                                    <div>
                                        <div class="senderInfoFont">{{ message.senderDisplayName }}</div>
                                        <div class="senderInfoFont">{{message.createdOn | date : 'HH:mm:ss'}}</div>
                                    </div>
                                    <div class="messageThread">
                                        <span class="m-1" [innerHTML]="message.message" ></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-right m-1 senderChatMessage" *ngIf="message.senderDisplayName!=undefined && message.message!=undefined">
                        <div *ngIf="calleeTeamsUserId == message?.sender?.communicationUserId">
                            <div class="senderReceiver">
                                <div class="m-1">
                                    <div>
                                        <div class="senderInfoFont">
                                            {{ message.senderDisplayName }}
                                        </div>
                                        <div class="senderInfoFont">
                                            {{message.createdOn | date : 'HH:mm:ss'}}
                                        </div>
                                    </div>
                                    <div class="messageThread">
                                        <span class="m-1" [innerHTML]="message.message"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center userLeft" *ngIf="message.isUserLeft">
                        {{message.userLeftMessage}}
                    </div>
                </div>
                <div id="scrollToBottom"></div>
            </div>
            <form [formGroup]="videoForm">
                <div *ngIf="isFileUploading" class="d-flex p-0 m-0 mt-2 fileUploadNotification"> <div class="fileuploadspinner"></div> <div>Your File is Uploading. Please wait!</div>  </div>
                <div class="input-group mb-2">
                    <a>
                        <input type="file" style="display: none;" (change)="sendFileInChat($event)" id="fileInput">
                        <label for="fileInput" class="btn">
                            <i class="fa fa-paperclip" aria-hidden="true"></i>
                        </label>  
                    </a>
                    <input formControlName="userChatTest" id="chat-text" type="text" placeholder="Type a message" autocomplete="off" (keyup.enter)="sendChatMessage()" class="form-control" />
                    <button id="send-chat-message" type="button" class="btn" (click)="sendChatMessage()">
                        <span><em class="fa fa-arrow-right" aria-hidden="true"></em></span>
                    </button>
                </div>
                <div>

                </div>
            </form>
        </div>
        <div [ngClass]="{
            'col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 m-0 p-0' : showUserList, 
            'd-none': !showUserList || showMessageBox && !isScreenShared
            }" 
            class="chatbox-container border" >
            <div class="row m-0 p-0">
                <div class="col-8 m-0 p-0 defaultBackground">
                    <!-- <p *ngIf="remoteParticipantsState.length == 1" class="m-0 mt-2 mb-2 p-0 text-center" >
                        <span class="totalParticipantHeading" >TOTAL PARTICIPANT 
                            <span *ngIf="remoteParticipantsState.length > 0" >: {{remoteParticipantsState.length+1}}</span>
                        </span>
                    </p> -->
                    <p class="m-0 mt-2 mb-2 p-0 text-center" >
                        <span class="totalParticipantHeading" >TOTAL PARTICIPANTS 
                            <span>: {{remoteParticipantsState.length+1}}</span>
                        </span>
                        <!-- <a *ngIf="isAdmin" title="Mute All Participants" class="m-1 btn btn-sm" type="button" (click)="muteAllParticipant()">Mute All</a> -->
                    </p>
                </div>
                <div class="col-4 d-flex justify-content-center align-items-center">
                    <a *ngIf="isAdmin" title="Mute All Participants" class="anchortag" type="button" (click)="muteAllParticipant()">Mute All</a>
                </div>
            </div>
            <div class="chatThreadContainer">
                <div class="row justify-content-center align-items-center mt-2 mb-2 m-0 p-0">
                    <div class="col-12 m-0 p-0" >
                        <div class="m-0 p-2 d-flex justify-content-center align-items-center">
                            <p class="m-0 p-0" class="userInitialLogoUserListNo text-center p-2 m-0">
                                {{localUserNameInitials}}
                            </p>
                            <p class="m-0 p-1 userNameText" title="{{ localUserName }}">
                                {{localUserName}} (You)
                            </p>    
                            <p class="m-0 p-1" *ngIf="!showUserInitialLocal">
                                <img class="userlistSvg"  src="./assets/meetingIcons/Video.svg" alt="">
                            </p>
                            <p class="m-0 p-1" *ngIf="showUserInitialLocal">
                                <img class="userlistSvg" src="./assets/meetingIcons/Video-Off.svg" alt=""> 
                            </p>
                            <p class="m-0 p-1" *ngIf="unMuteButton">
                                <img class="userlistSvg"  src="./assets/meetingIcons/UnMute.svg" alt="">
                            </p>
                            <p class="m-0 p-1" *ngIf="muteButton">
                                <img class="userlistSvg"   src="./assets/meetingIcons/Mute.svg" alt="">
                            </p>
                        </div>
                    </div>
                </div>
                <ng-container *ngFor="let participant of remoteParticipantsState">
                    <div class="row justify-content-center align-items-center mt-2 mb-2 m-0 p-0" id={{participant.id}}>
                        <div class="col-12 m-0 p-0" >
                            <div class="m-0 p-2 d-flex justify-content-center align-items-center">
                                <p class="m-0 p-0" class="userInitialLogoUserListNo text-center p-2 m-0">
                                    {{createUserInitials(participant.remoteParticipant._displayName)}}
                                </p>
                                <p class="m-0 p-1 userNameText" title="{{ participant.remoteParticipant._displayName }}">
                                    {{ participant.remoteParticipant._displayName }}
                                </p>
                                <ng-container *ngFor="let videoType of participant.remoteParticipant.videoStreams">
                                    <ng-container *ngIf="videoType._mediaStreamType == 'Video'">
                                        <p class="m-0 p-1" *ngIf="videoType._isAvailable">
                                            <img class="userlistSvg"  src="./assets/meetingIcons/Video.svg" alt="">
                                        </p>
                                        <p class="m-0 p-1" *ngIf="!videoType._isAvailable">
                                            <img class="userlistSvg" src="./assets/meetingIcons/Video-Off.svg" alt=""> 
                                        </p>
                                    </ng-container>
                                </ng-container>
                                <p class="m-0 p-1" *ngIf="participant.remoteParticipant._isMuted">
                                    <img class="userlistSvg"  src="./assets/meetingIcons/UnMute.svg" alt="">
                                </p>
                                <p class="m-0 p-1" *ngIf="!participant.remoteParticipant._isMuted && !isAdmin">
                                    <img class="userlistSvg"   src="./assets/meetingIcons/Mute.svg" alt="">
                                </p>
                                <p class="m-0 p-1" *ngIf="!participant.remoteParticipant._isMuted && isAdmin">
                                    <a class="anchortag" (click)="muteParticularParticipant(participant.remoteParticipant)" >
                                        <img class="userlistSvg"   src="./assets/meetingIcons/Mute.svg" alt="">
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>                 
                </ng-container>
            </div>
        </div>
    </div>
    <div [hidden]="!higherScreenRes || !higherScreenResUser" id="userControlsDiv" class="userControlsDiv">
        <div class="row m-0 p-0">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 m-0 p-0">
                <div [hidden]="showUserInitialLocal" class="d-flex justify-content-center">
                    <div *ngIf="localVideoOn">
                        <app-local-video-stream [localVideoPreview]="localVideo" ></app-local-video-stream>
                    </div>
                    <div [hidden]="!showUserInitialLocal" class="userInitialLogoLocal">
                        <div class="m-0 p-0 d-flex justify-content-center align-items-center">
                            {{localUserNameInitials}} (You)
                        </div>
                    </div>
                </div>                
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 m-0 p-0">
                <div class="text-center mt-1 mb-1">
                    <strong>{{meetingTitle}}</strong>
                </div>
                <div class="d-flex justify-content-center">
                    <button *ngIf="startVideoButton" title="Turn on Video"  class="m-1 btn btn-sm" id="start-video-button" type="button" (click)="startVideoButtonClick()"><img class="buttonImg" src="./assets/meetingIcons/Video-Off.svg" alt=""></button>
                    <button *ngIf="stopVideoButton" title="Turn off Video"  class="m-1 btn btn-sm" id="stop-video-button" type="button" (click)="stopVideoButtonClick()"><img class="buttonImg" src="./assets/meetingIcons/Video.svg" alt=""></button>
                    <button *ngIf="muteButton && isAudioControlEnabled" title="Turn off mic"  class="m-1 btn btn-sm" id="mute-audio-button" type="button" (click)="muteAudioButtonClick()"><img class="buttonImg" src="./assets/meetingIcons/Mute.svg" alt=""></button>
                    <button *ngIf="unMuteButton && isAudioControlEnabled" title="Turn on mic"  class="m-1 btn btn-sm" id="unmute-audio-button" type="button" (click)="unMuteAudioButtonClick()"><img class="buttonImg" src="./assets/meetingIcons/UnMute.svg" alt=""></button>
                    <button *ngIf="startScreenShareButton" title="Start Screen Share"  class=" btn btn-sm m-1" id="start-screen-share" type="button" (click)="startScreenShareButtonClick()" ><img class="buttonImg" src="./assets/meetingIcons/ScreenShare.svg" alt=""></button>
                    <button *ngIf="stopScreenShareButton" title="Stop Screen Share"  class=" btn btn-sm m-1" id="stop-screen-share" type="button" (click)="stopScreenShareButtonClick()"  ><img class="buttonImg" src="./assets/meetingIcons/Screenoff.svg" alt=""></button>
                    <button *ngIf="!showMessageBox && isChatEnabled" title="Open chat box" (click)="showMessageBoxMethod()" class="btn btn-sm d-none d-md-block m-1"> <img class="buttonImg" src="./assets/meetingIcons/chat.svg" alt="">
                        <span *ngIf="chatMessageCounter.length>0" >{{chatMessageCounter.length}}</span>
                    </button>
                    <button *ngIf="showMessageBox" title="Close chat box" (click)="hideMessageBoxMethod()" class="btn btn-sm d-none d-md-block m-1"> <img class="buttonImg" src="./assets/meetingIcons/chat.svg" alt=""></button>
                    <button *ngIf="!showUserList" title="Open Participants list" (click)="showUserListBoxMethod()" class="btn btn-sm d-none d-md-block m-1"> <img class="buttonImg" src="./assets/meetingIcons/GroupUser.svg" alt="">
                        <span *ngIf="remoteParticipantsState.length>0" >{{remoteParticipantsState.length+1}}</span>
                    </button>
                    <button *ngIf="showUserList" title="Close Participants list" (click)="HideUserListBoxMethod()" class="btn btn-sm d-none d-md-block m-1"> <img class="buttonImg" src="./assets/meetingIcons/GroupUser.svg" alt=""></button>
                    <button title="Open Participants list" (click)="showHideMessageBoxUserRes()" class="btn btn-sm d-md-none m-1"> <img class="buttonImg" src="./assets/meetingIcons/GroupUser.svg" alt="">
                        <span *ngIf="remoteParticipantsState.length>0" >{{remoteParticipantsState.length+1}}</span>
                    </button>
                    <button *ngIf="isChatEnabled" title="Close chat box" (click)="showHideMessageBoxRes()" class="btn btn-sm d-md-none m-1"><img class="buttonImg" src="./assets/meetingIcons/chat.svg" alt=""> 
                        <span *ngIf="chatMessageCounter.length>0" >{{chatMessageCounter.length}}</span>
                    </button>

                    <button *ngIf="!isAdmin" title="Leave Call" class="m-1 btn btn-sm" id="hangup-call-button" type="button" (click)="leaveCallConfirmationPopup()"><img class="buttonImg" src="./assets/meetingIcons/call.svg" alt="">Leave</button>
                    <button *ngIf="isAdmin" title="End Meeting" class="m-1 btn btn-sm" type="button" (click)="endCallConfirmationPopup(remoteParticipantsState)"><img class="buttonImg" src="./assets/meetingIcons/call.svg" alt="">End</button>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 m-0 p-0 d-flex justify-content-center align-items-center">
                <ng-container *ngIf="!showUserList">
                    <div *ngIf="remoteParticipantsState.length>9" (click)="showUserListBoxMethod()" class="userInitialLogoLocalUserCounnt d-none d-md-block">
                        <div>+{{remoteParticipantsState.length-9}} User</div>
                    </div>
                </ng-container>
                <ng-container *ngIf="showUserList">
                    <div *ngIf="remoteParticipantsState.length>9" (click)="HideUserListBoxMethod()" class="userInitialLogoLocalUserCounnt d-none d-md-block">
                        <div>+{{remoteParticipantsState.length-9}} User</div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!showUserList">
                    <div *ngIf="remoteParticipantsState.length>9" (click)="showHideMessageBoxUserRes()" class="userInitialLogoLocalUserCounnt d-md-none">
                        <div>+{{remoteParticipantsState.length-9}} User</div>
                    </div>
                </ng-container>
                <ng-container *ngIf="showUserList">
                    <div *ngIf="remoteParticipantsState.length>9" (click)="showHideMessageBoxUserRes()" class="userInitialLogoLocalUserCounnt d-md-none">
                        <div>+{{remoteParticipantsState.length-9}} User</div>
                    </div>
                </ng-container>
                
            </div>
        </div>
    </div>
    <div *ngIf="isChatEnabled" [hidden]="higherScreenRes" class="row d-md-none">
        <div class="col">
            <div class="chatbox-container">
                <div>
                    <button  (click)="showHideMessageBoxRes()" class="btn">Close</button>
                </div>
                <div #chatContainerMob class="chatThreadContainerMob" [ngClass]="{'chatThreadContainerMob':!isFileUploading,'chatThreadContainerMobWhileFileUpload':isFileUploading}">
                    <div *ngFor="let message of chatMessages; let i = index">
                        <div class="text-left m-1 receiverChatMessage"
                            *ngIf="message.senderDisplayName!=undefined && message.message!=undefined ">
                            <div *ngIf="calleeTeamsUserId != message?.sender?.communicationUserId">
                                <div class="senderReceiver">
                                    <div class="m-1">
                                        <div class=" ">
                                            <div class="senderInfoFont">
                                                {{ message.senderDisplayName }}
                                            </div>
                                            <div class="senderInfoFont">
                                                {{message.createdOn | date : 'HH:mm:ss'}}
                                            </div>
                                        </div>
                                        <div class="messageThread">
                                            <span class="m-1" [innerHTML]="message.message" ></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-right m-1 senderChatMessage" *ngIf="message.senderDisplayName!=undefined && message.message!=undefined">
                            <div *ngIf="calleeTeamsUserId == message?.sender?.communicationUserId">
                                <div class="senderReceiver">
                                    <div class="m-1">
                                        <div class=" ">
                                            <div class="senderInfoFont">
                                                {{ message.senderDisplayName }}
                                            </div>
                                            <div class="senderInfoFont">
                                                {{message.createdOn | date : 'HH:mm:ss'}}
                                            </div>
                                        </div>
                                        <div class="messageThread">
                                            <span class="m-1" [innerHTML]="message.message" ></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center userLeft" *ngIf="message.isUserLeft">
                            {{message.userLeftMessage}}
                        </div>
                    </div>
                </div>
                <div>
                        <form [formGroup]="videoForm">
                            <div *ngIf="isFileUploading" class="d-flex p-0 m-0 mt-2 fileUploadNotification"> <div class="fileuploadspinner"></div> <div>Your File is Uploading. Please wait!</div>  </div>
                            <div class="input-group  mb-2">
                            <a>
                                <input type="file" style="display: none;" (change)="sendFileInChat($event)" id="fileInputMob">
                                <label for="fileInputMob" class="btn">
                                    <i class="fa fa-paperclip" aria-hidden="true"></i>
                                </label>  
                            </a>
                            <input formControlName="userChatTest" id="chat-text" type="text" placeholder="Type a message" autocomplete="off" class="form-control" />
                            <button id="send-chat-message" type="button" class="btn" (click)="sendChatMessage()">
                                <span> <em class="fa fa-arrow-right" aria-hidden="true"></em></span>
                            </button>
                            </div>
                        </form>
                   
                </div>
            </div>
        </div>
    </div>
    <div [hidden]="higherScreenResUser" class="row d-md-none">
        <div class="col">
            <div class="chatbox-container">
                <div>
                    <button  (click)="showHideMessageBoxUserRes()" class="btn">Close</button>
                </div>
                <br>
                <div class="row m-0 p-0">
                    <div class="col-8 m-0 p-0 defaultBackground">
                        <!-- <p *ngIf="remoteParticipantsState.length == 1" class="m-0 mt-2 mb-2 p-0 text-center" >
                            <span class="totalParticipantHeading" >TOTAL PARTICIPANT 
                                <span *ngIf="remoteParticipantsState.length > 0" >: {{remoteParticipantsState.length+1}}</span>
                            </span>
                        </p> -->
                        <p class="m-0 mt-2 mb-2 p-0 text-center" >
                            <span class="totalParticipantHeading" >TOTAL PARTICIPANTS 
                                <span>: {{remoteParticipantsState.length+1}}</span>
                            </span>
                            <!-- <a *ngIf="isAdmin" title="Mute All Participants" class="m-1 btn btn-sm" type="button" (click)="muteAllParticipant()">Mute All</a> -->
                        </p>
                    </div>
                    <div class="col-4 d-flex justify-content-center align-items-center">
                        <a *ngIf="!isAdmin" title="Mute All Participants" class="anchortag" type="button" (click)="muteAllParticipant()">Mute All</a>
                    </div>
                </div>
                <div class="row justify-content-center align-items-center mt-2 mb-2 m-0 p-0">
                    <div class="col-12 m-0 p-0" >
                        <div class="m-0 p-2 d-flex justify-content-center align-items-center">
                            <p class="m-0 p-0" class="userInitialLogoUserListNo text-center p-2 m-0">
                                {{localUserNameInitials}}
                            </p>
                            <p class="m-0 p-1 userNameText" title="{{ localUserName }}">
                                {{ localUserName }} (You)
                            </p>    
                            <p class="m-0 p-1" *ngIf="!showUserInitialLocal">
                                <img class="userlistSvg"  src="./assets/meetingIcons/Video.svg" alt="">
                            </p>
                            <p class="m-0 p-1" *ngIf="showUserInitialLocal">
                                <img class="userlistSvg" src="./assets/meetingIcons/Video-Off.svg" alt=""> 
                            </p>
                            <p class="m-0 p-1" *ngIf="unMuteButton">
                                <img class="userlistSvg"  src="./assets/meetingIcons/UnMute.svg" alt="">
                            </p>
                            <p class="m-0 p-1" *ngIf="muteButton">
                                <img class="userlistSvg"   src="./assets/meetingIcons/Mute.svg" alt="">
                            </p>
                        </div>
                    </div>
                </div>
                <ng-container *ngFor="let participant of remoteParticipantsState">
                    <div class="row justify-content-center align-items-center mt-2 mb-2 m-0 p-0" id={{participant.id}}>
                        <div class="col-12 m-0 p-0" >
                            <div class="m-0 p-2 d-flex justify-content-center align-items-center">
                                <p class="m-0 p-0" class="userInitialLogoUserListNo text-center p-2 m-0">
                                    {{createUserInitials(participant.remoteParticipant._displayName)}}
                                </p>
                                <p class="m-0 p-1 userNameText" title="{{ participant.remoteParticipant._displayName }}">
                                    {{ participant.remoteParticipant._displayName }}
                                </p>
                                <ng-container *ngFor="let videoType of participant.remoteParticipant.videoStreams">
                                    <ng-container *ngIf="videoType._mediaStreamType == 'Video'">
                                        <p class="m-0 p-1" *ngIf="videoType._isAvailable">
                                            <img class="userlistSvg"  src="./assets/meetingIcons/Video.svg" alt="">
                                        </p>
                                        <p class="m-0 p-1" *ngIf="!videoType._isAvailable">
                                            <img class="userlistSvg" src="./assets/meetingIcons/Video-Off.svg" alt=""> 
                                        </p>
                                    </ng-container>
                                </ng-container>
                                <p class="m-0 p-1" *ngIf="participant.remoteParticipant._isMuted">
                                    <img class="userlistSvg"  src="./assets/meetingIcons/UnMute.svg" alt="">
                                </p>
                                <p class="m-0 p-1" *ngIf="!participant.remoteParticipant._isMuted && !isAdmin">
                                    <img class="userlistSvg"   src="./assets/meetingIcons/Mute.svg" alt="">
                                </p>
                                <p class="m-0 p-1" *ngIf="!participant.remoteParticipant._isMuted && isAdmin">
                                    <a class="anchortag" (click)="muteParticularParticipant(participant.remoteParticipant)" >
                                        <img class="userlistSvg"   src="./assets/meetingIcons/Mute.svg" alt="">
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>               
                </ng-container>
            </div>
        </div>
    </div>
</div> 